<app-modal-template
  [title]="'Save Recording' | translate"
  [size]="pencilModalSizeEnum.LARGE"
  [hasCloseButton]="true"
  [showActionsDivider]="true"
  (closeButtonClicked)="dismiss()"
  [class]="'recorder-modal'"
>
  <div class="description" content-description>
    <div class="preview-recording" [hidden]="isLoadingMetadata">
      <video #previewRecording></video>
    </div>
  </div>
  <div class="actions-box" content-actions>
    <div class="recorder-actions">
      <app-pencil-button
        [theme]="'secondary'"
        class="discard-button"
        [icon]="'close'"
        [iconConfig]="{ type: IconTypes.matIcon }"
        (clickEvent)="dismiss()"
        [label]="'Discard' | translate"
      ></app-pencil-button>
      <app-pencil-button
        theme="primary"
        class="save-button"
        icon="check"
        [iconConfig]="{ type: IconTypes.matIcon }"
        [label]="'Save' | translate"
        (clickEvent)="confirm()"
      ></app-pencil-button>
    </div>
  </div>
</app-modal-template>
